import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Dialog from "src/components/Dialog";
import { resetState } from "../duck/actions";

export default function RejectionDialog({ exceededDeviceLimit }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const button = {
    text: t("buttons.ok"),
    onClick: () => {
      dispatch(resetState());
    }
  };
  const heading = exceededDeviceLimit
    ? t("pairing.requester.rejectionDialog.heading")
    : t(`pairing.requester.rejectionDialog.heading`);
  const text = exceededDeviceLimit
    ? t("pairing.requester.rejectionDialog.deviceLimit")
    : t(`pairing.requester.rejectionDialog.text`);

  return (
    <Dialog
      isOpen={true}
      type="failure"
      buttons={[button]}
      heading={heading}
      text={text}
    />
  );
}
